"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyTokenPermissions = exports.isDecodedToken = exports.TokenScope = void 0;
var TokenScope;
(function (TokenScope) {
    TokenScope["ACCESS"] = "access";
    TokenScope["DOWNLOAD"] = "download";
    TokenScope["LOGIN"] = "login";
})(TokenScope = exports.TokenScope || (exports.TokenScope = {}));
const isDecodedToken = (input) => {
    return (typeof input === 'object' &&
        input !== null &&
        !(input instanceof Array) &&
        'userId' in input &&
        'email' in input &&
        'scope' in input);
};
exports.isDecodedToken = isDecodedToken;
const applyTokenPermissions = (decodedToken) => {
    const isAdmin = decodedToken.role === 'admin';
    const isAuthenticated = !!decodedToken.userId;
    return {
        ...decodedToken,
        canView: isAuthenticated,
        canDataEntry: isAdmin,
        canExport: isAdmin,
        canViewSources: isAdmin,
        canBrowseLongLists: isAdmin,
    };
};
exports.applyTokenPermissions = applyTokenPermissions;
//# sourceMappingURL=UpstreamToken.js.map